import StrapiBannerDescription from './StrapiBannerDescription';

export default StrapiBannerDescription;
